import React from 'react'
import banner from '../../assets/Carousel/St Albans Banner 01.png'

const DigitOffset = () => {
   
  return (
    <div>
      <div className='relative w-full h-full mb-5 sm:mb-16'>
        <img src={banner} alt="offset banner"/>
        <div className='absolute top-0 w-full h-full bg-black/40 flex items-center justify-center'>
          <h1 className='text-2xl sm:text-4xl font-medium text-white drop-shadow-md'>Digital & Offset Printing</h1>
        </div>
      </div>
      <div className='px-5 sm:px-10 pb-8 sm:pb-16'>
        
        <div className='px-4 md:px-14'>
          <div className='sm:px-4 py-6 lg:col-span-3 flex flex-col items-center'>
              <h1 className='text-3xl sm:text-4xl font-bold mb-4 sm:mb-8 text-neutral-800'>Digital and Offset Printing</h1>
               <div className='flex flex-col gap-y-3 sm:gap-y-6 text-neutral-700 text-base sm:text-lg'>
  <p className='sm:leading-8'>
   At St. Albans Digital Printing, we offer an extensive assortment of print solutions tailored to meet the diverse needs of our clients. With years of expertise and continuous upgrades to our printing infrastructure, we have become synonymous with the finest quality printing. By embracing new technologies and innovative techniques, we ensure that we remain at the forefront of the printing industry.
  </p> 

  <p className='sm:leading-8'>
 In both offset and digital printing, we provide complete printing solutions and specialize in a wide range of products, including books, e-journals, journals, magazines, leaflets, flyers, brochures, calendars, posters, newsletters, wedding and invitation cards, postcards, labels, corporate stationery, banners, and funeral or obituary printing. Our capabilities extend to creating obituary booklets and much more, ensuring that we can fulfill all your printing needs.We also design customized digital journals for organizations hosting gala events. Displayed on state-of-the-art tablets, these journals create an interactive experience for your guests while saving you time and money. This innovative approach signifies a major advancement in how fundraising events are promoted and how funds are raised, offering a unique and engaging way to connect with attendees.
  </p>

  <p className='sm:leading-8'>
  Our reputation for providing quality printing at affordable costs, delivered on time, sets us apart. Whether you need black-and-white or vibrant, full-color prints, our advanced printing machines are equipped to deliver exceptional results. Placing an order is simple—submit your request online or visit us at 199-12 Linden Blvd, Saint Albans, NY 11412. Let St. Albans Digital Printing Inc. help you create stunning printed materials that effectively communicate your message and elevate your brand’s presence.
  </p>
  <p className='sm:leading-8'>
  <strong>Popular Digital and Offset Printing Services</strong> 
  </p>
   <p className='sm:leading-8'>
   ➔	Custom Marketing Materials: Professionally printed brochures, flyers, and postcards that enhance brand visibility and engage customers effectively.
  </p>
  <p className='sm:leading-8'>
  ➔	Event Programs: Ideal for concerts, conferences, and weddings, providing organized schedules and essential information for attendees.
  </p>
  <p className='sm:leading-8'>
  ➔	Corporate Stationery: Custom letterheads, business cards, and envelopes that reinforce brand identity and professionalism in communications.
  </p>
  <p className='sm:leading-8'>
  ➔	Product Catalogs: Showcase products and services in a visually appealing format, making it easy for customers to browse and make informed decisions.
  </p>
  <p className='sm:leading-8'>
 ➔	Posters and Banners: Large-format prints for advertising and promotions, designed to capture attention and convey messages effectively.
  </p>

  <p className='sm:leading-8'>
  ➔	Newsletters: Regularly printed newsletters to keep clients and stakeholders informed about company updates and events.
  </p>
  <p className='sm:leading-8'>
  ➔	Wedding and Invitation Cards: Custom-designed invitations that reflect the theme and style of the event, making a lasting impression on guests.
  </p>
  <p className='sm:leading-8'>
➔	Funeral and Obituary Printing: Thoughtfully designed materials to honor loved ones, including obituary booklets and memorial programs.
  </p>
  <p className='sm:leading-8'>
  ➔	Educational Materials: Printed materials such as textbooks and instructional guides that facilitate learning and engagement in educational settings.
  </p>
  
        

        
</div>

              {/* --- Images from APi  */}
              <div>
                {/* ImageX3 in grid */}
              </div>
          </div>  
        </div>

      </div>
    </div>
  )
}

export default DigitOffset
